//花光十个亿模式的所有事件
export enum SPEND_MODE_EVENT{
    //切天将事件初始化
    SPEND_OBJ_INIT = "speed-obj-init",
}

export enum SPEND_MODE_EVENT_TYPE{
    //圆梦事件
    DREAM,
    //NPC主线
    NPC,
    //支线
    BRANCH
}